import { configurationTabEntryPoint } from '@atlassian/jira-assets-data-manager-data-source/src/ui/tabs/configuration/entrypoint.tsx';
import { activityTabEntryPoint } from '@atlassian/jira-assets-data-manager-data-source/src/ui/tabs/activity/entrypoint.tsx';
import { dataTabEntryPoint } from '@atlassian/jira-assets-data-manager-data-source/src/ui/tabs/data/entrypoint.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { DataSourceTabName } from '@atlassian/jira-assets-data-manager-common/src/common/types.tsx';

const TABS = {
	activity: activityTabEntryPoint,
	configuration: configurationTabEntryPoint,
	data: dataTabEntryPoint,
} as const;

const DEFAULT_TAB: DataSourceTabName = 'configuration';

const isValidTab = (tab: unknown): tab is DataSourceTabName =>
	typeof tab === 'string' && Object.keys(TABS).includes(tab);

export const assetsDataManagerDataSourceEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-assets-data-manager-data-source", jiraSpaEntry: "async-assets-data-manager-data-source" */ './src'
			),
	),
	getPreloadProps: ({
		context: {
			match: { params },
		},
	}: EntryPointRouteParams) => {
		const validTab = isValidTab(params?.tab) ? params.tab : DEFAULT_TAB;
		const extraProps = {
			jobId: params?.dataSourceId || '',
		};
		return {
			entryPoints: {
				[validTab]: {
					entryPoint: TABS[validTab],
					entryPointParams: {},
				},
			},
			extraProps,
		};
	},
});
